import { SvgIcon, SvgIconProps } from '@mui/material';

export function MoreVirtIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="more_vert" clipPath="url(#clip0_661_2435)">
          <path
            id="Vector"
            d="M12.5 8.00098C13.6 8.00098 14.5 7.10098 14.5 6.00098C14.5 4.90098 13.6 4.00098 12.5 4.00098C11.4 4.00098 10.5 4.90098 10.5 6.00098C10.5 7.10098 11.4 8.00098 12.5 8.00098ZM12.5 10.001C11.4 10.001 10.5 10.901 10.5 12.001C10.5 13.101 11.4 14.001 12.5 14.001C13.6 14.001 14.5 13.101 14.5 12.001C14.5 10.901 13.6 10.001 12.5 10.001ZM12.5 16.001C11.4 16.001 10.5 16.901 10.5 18.001C10.5 19.101 11.4 20.001 12.5 20.001C13.6 20.001 14.5 19.101 14.5 18.001C14.5 16.901 13.6 16.001 12.5 16.001Z"
            fill="currentcolor"
          />
        </g>
        <defs>
          <clipPath id="clip0_661_2435">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0.5 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
